/**
 * Composition of a company name with its legal-form (ОПФ) ending.
 *
 * The same six names the registration summary renders
 * (shared/components/registration/nature-of-business-section) also drive the CHANGE_NAME
 * post-reg event diff, so both must join stem and ending the same way.
 */
export class CompanyNameHelper {


  static compose(name: string | null | undefined, ending: string | null | undefined): string | null {
    const stem = (name ?? '').trim();
    const suffix = (ending ?? '').trim();
    if (!stem) {
      return null;
    }
    if (!suffix) {
      return stem;
    }
    if (suffix.includes(CompanyNameHelper.TEMPLATE_VALUE)) {
      // split/join rather than String.replace: replace would read `$&` / `$'` inside a company
      // name as substitution patterns.
      return suffix.split(CompanyNameHelper.TEMPLATE_VALUE).join(stem);
    }
    // No template: either a genuine standalone suffix, or an ending already folded into the
    // stem — appending the latter would repeat it.
    return stem === suffix || stem.endsWith(` ${suffix}`)
      ? stem
      : `${stem} ${suffix}`;
  }

  private static readonly TEMPLATE_VALUE = '[value]';
}
